const UnStar = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 297 297"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="#a7dbc7"
        d="M296.519,114.329c-1.142-3.512-4.15-6.088-7.795-6.674l-89.94-14.441l-41.528-81.074c-1.684-3.287-5.064-5.352-8.755-5.352
       c-3.691,0-7.071,2.064-8.755,5.352L98.217,93.214l-89.94,14.441c-3.645,0.586-6.653,3.162-7.795,6.674
       c-1.141,3.51-0.22,7.363,2.385,9.979l64.272,64.55l-14.056,90.001c-0.569,3.648,0.95,7.306,3.937,9.476
       c2.986,2.17,6.937,2.485,10.229,0.816l81.252-41.18l81.252,41.18c1.405,0.713,2.929,1.063,4.446,1.063
       c2.04,0,4.069-0.635,5.782-1.879c2.986-2.17,4.506-5.827,3.937-9.476l-14.056-89.999l64.273-64.552
       C296.739,121.692,297.659,117.839,296.519,114.329z M212.404,178.509c-2.211,2.221-3.232,5.362-2.748,8.459l11.862,75.954
       l-68.571-34.753c-2.795-1.416-6.098-1.416-8.893,0l-68.571,34.753l11.862-75.956c0.484-3.097-0.537-6.238-2.748-8.459l-54.24-54.474
       l75.902-12.188c3.095-0.497,5.767-2.438,7.195-5.228L148.5,38.198l35.046,68.421c1.429,2.79,4.101,4.731,7.195,5.228l75.902,12.188
       L212.404,178.509z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  )
}

export default UnStar
